import { makeVar } from '@apollo/client'
import { ProjectFragment, ProjectVersionFragment } from '../generated/graphql'
import { EnergyType } from '../calculators/EnergyFlow'
import {
  Dictionaries,
  emptyDictionaries,
} from '../components/common/util/dictionary-util'

// These are used only as types
import type { VersionCalculator } from '../calculators/VersionCalculator'
import type { VersionCostCalculator } from '../calculators/costs/VersionCostCalculator'
import type { SelectedVersion } from '../components/layout/VersionsSelector'

export const projectVar = makeVar<ProjectFragment | null>(null)
export const activeVersionVar = makeVar<ProjectVersionFragment | null>(null)
export const calculatorVar = makeVar<VersionCalculator | null>(null)
export const comparisonVersionVar = makeVar<ProjectVersionFragment | null>(null)
export const comparisonVersionCalculatorVar = makeVar<VersionCalculator | null>(
  null,
)
export const buildingEnergyTypeVar = makeVar(EnergyType.Heating)
export const localGridEnergyTypeVar = makeVar(EnergyType.Heating)
export const isComparisonVisibleVar = makeVar(false)

export const selectedVersionsVar = makeVar<SelectedVersion[]>([])
export const isCostCalculationSuccessVar = makeVar(false)
export const selectedCostCalculatorsVar = makeVar<VersionCostCalculator[]>([])
export const dictionariesVar = makeVar<Dictionaries>(emptyDictionaries)
